<template>
<el-dialog width="460px"  title="修改密码" ref="dialog" v-model="dialogVisible" :before-close="handleClose">
  <div class="containers">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="密码" prop="pass">
        <el-input
          type="password"
          v-model="ruleForm.pass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
     
      <el-form-item label="确认密码" prop="checkPass">
        <el-input
          type="password"
          v-model="ruleForm.checkPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
  </el-dialog>
</template>

<script>
import { sha256 } from '@/util/encryption';
export default {
  emits: ["password-submitForm", "password-close"],
  components: {
    
  },
  props:{
      dialogVisible:false
  },
  mounted() {
     // //debugger;  
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: ["blur", "change"] }],
        checkPass: [{ validator: validatePass2, trigger: ["blur", "change"] }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
            //debugger
        if (valid) {
             // //debugger
           this.$emit("password-submitForm",0,sha256(this.ruleForm.checkPass))   
           this.resetForm()
        } else {          
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
     handleClose(){
       this.$emit("password-close")    
     },
     handleCancel() {
         handleClose();
     },     
  },
};
</script>
<style scoped>
.containers {
  padding-right: 100px !important;
  padding: 30px;
  width: 300px;
  height: 150px;

}
</style>
